<template>
  <!--  云商严选图标-->
  <div
    v-if="labelItem.tagContent"
    class="cloud-shop-selected"
    :style="labelStyle"
  >
    <div :style="{ color: labelItem.wordColor }">
      {{ labelItem.tagContent }}
    </div>
  </div>
  <!--      自营、联营、集采、自采等标签-->
  <div style="display: inline-block;vertical-align: bottom;" v-else>
    <div v-for="type in typeList" :key="type" style="display: inline-block">
      <div :class="`${typeMap.get(type)}`">
        <div>{{ type }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "goods-tag",
  props: {
    typeList: {
      type: Array,
      default() {
        return [];
      }
    },
    labelItem: {
      type: Object,
      default() {
        return {};
      }
    },
    shopName: {
      type: String,
      default() {
        return "";
      }
    }
  },
  computed: {
    labelStyle() {
      return {
        color: this.labelItem.wordColor || "#000", // 设置默认颜色
        marginRight: "10px",
        background: this.labelItem.backgroundColor || "#fff"
      };
    }
  },

  data() {
    return {
      typeMap: new Map([
        ["集采", "concentrated-purchasing-tag"],
        ["联采", "combined-purchasing-tag"],
        ["自采", "self-purchasing-tag"],
        ["自营", "self-run-tag"]
      ])
    };
  }
};
</script>

<style lang="scss">
.shop-type {
  display: inline-block;
  /*width: 51px;*/
  height: 18px;
  background: #ff142f;
  border-radius: 9px;
  padding: 0 7px;
  box-sizing: border-box;
  div {
    /*width: 36px;*/
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 17px;
  }
}

@mixin tag-background {
  /*width: 34px;*/
  height: 18px;
  border-radius: 4px;
  padding: 0 5px;
  margin-right: 5px;
  box-sizing: border-box;
  display: inline-block;
}

@mixin tag-font {
  /*width: 24px;*/
  height: 17px;
  font-size: 12px;
  line-height: 17px;
  font-weight: 400;
}
.cloud-shop-selected {
  @include tag-background;
  display: inline-block;
  vertical-align: bottom;
  padding: 0 5px;
  height: 17px;
  font-size: 12px;
  line-height: 17px;
}
.concentrated-purchasing-tag {
  @include tag-background;
  background: #ff142f;

  div {
    @include tag-font;
    font-weight: 500;
    color: #ffffff;
  }
}

.combined-purchasing-tag {
  @include tag-background;
  background: #f5a623;

  div {
    @include tag-font;
    color: #ffffff;
  }
}

.self-purchasing-tag {
  @include tag-background;
  background: #0089ef;

  div {
    @include tag-font;
    color: #ffffff;
  }
}

.self-run-tag {
  @include tag-background;
  border: 1px solid #ff142f;
  padding: 0 4px;
  div {
    @include tag-font;
    color: #ff142f;
    line-height: 15px;
  }
}
</style>
